import helpChat from "./HelpChat/routes";
import notifications from "./Notifications/routes";
import profile from "./Profile/routes";
import WeeklyTime from "./WeeklyTime/WeeklyTime.vue";

// Main Home View
export default [{
    "path": "/",
    "component": () => import("./Home.vue"),
    "name": "Overview",
    "meta": {
        "app": "Home",
        "sideNav": true,
        "appSwitcher": false,
        "appSwitcherPosition": 0,
        "sideNavPosition": 0,
        "sideNavSection": "Overview",
        "icon": "home",
        "name": "Overview",
        "storeData": ["business/leave/events"]
    }
}, {
    path: "/Home/WeeklyTime",
    component: WeeklyTime,
    name: "WeeklyTime",
    meta: {
        app: "Home",
        name: "Weekly time",
        sideNav: false,
        appSwitcher: false,
        watch: false,
    }
}, ...notifications, ...profile, ...helpChat]
